import { useEffect } from 'react';

export function HomeSchema() {
  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '51漫画网',
        url: 'https://51manhua.com/',
        description: '51漫画网提供无删减韩国漫画下拉式阅读服务，免费韩漫大全题材丰富多样',
        foundingDate: '2018',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '51漫画网',
        url: 'https://51manhua.com/',
        description: '免费韩漫大全，无删减韩国漫画下拉式阅读平台',
        potentialAction: {
          '@type': 'SearchAction',
          'target': {
            '@type': 'EntryPoint',
            urlTemplate: 'https://51manhua.com/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
    ];

    const scriptId = 'schema-org-home';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas, null, 2);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return null;
}